<template>
	<div class="popup__wrap popup__wrap-match">
		<transition name="fade-popup" appear>
				<div class="popup">
					<div class="popup__wrap-box">
						<span class="popup__title section-title">
							{{ data.popupTitle }}
						</span>
						<PartInputSearch
							class="popup__search"
							:data="data.DataSearch"
							v-model="filter.search"
							ref="matchSearch"
						/>

					<transition name="fade-effect" appear>
						<BlockCustomTable
							v-show="items.length"
							class="popup__table popup__table--no-checkbox popup__table--small-image"
							:obj="{ ...data.DataMatchCustomer, items: items }"
							@loadMore="loadMore"
							@sortData="sortData"
							@sendEmailPopup="sendEmailPopup"
							:sort="sortDataObj.sortBy"
							ref="tableRef"
						/>
					</transition>

						<PartLoaderBig v-if="data.preloader || fetchInProgress"/>

					<transition name="fade-effect" appear>
						<PartNoResults
							class="popup__wrap-no-results"
							:data="DataNoResults"
							v-show="!items.length"
						/>
					</transition>

						<div class="popup-form__wrap-close-popup">
							<a href="javascript:" @click="closePopup">
								<SvgIcon class="close-icon" iconName="ico-close-sm"/>
							</a>
						</div>
					</div>
				</div>
		</transition>
	</div>
</template>

<script>
import PartInputSearch from '@/components/parts/PartInputSearch';
import BlockCustomTable from '@/components/blocks/BlockCustomTable';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNoResults from '@/components/parts/PartNoResults';
import PartLoaderBig from '@/components/parts/PartLoaderBig';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		sort: {
			type: String,
			required: false
		},
		parentType: {
			type: String,
			required: false
		}
	},
	data () {
		return {
			DataNoResults: {},
			type: 'BlockPopupMatchCustomer',
			fetchInProgress: false,
			filter: {
				search: ''
			},
			sortDataObj: {
				sortBy: '',
				order: ''
			},
			items: []
		};
	},
	computed: {
		propertyInfo() {
			return this.$store.getters.getPropertyInfo;
		},
		propertiesForMatchingPopupMatchCustomer() {
			return this.$store.getters.getPropertiesForMatchingPopupMatchCustomer;
		},
		customersForMatchingPopupMatchProperty() {
			return this.$store.getters.getCustomersForMatchingPopupMatchProperty;
		}
	},
	watch: {
		filter: {
			async handler() {
				const res = this.parentType === 'customer' ? await this.fetchPropertiesForMatching(true) : await this.fetchCustomersForMatching(true);
				this.items = res.data.properties ? res.data.properties : res.data.customers;
			},
			deep: true
		},
		sortDataObj: {
			async handler() {
				const res = this.parentType === 'customer' ? await this.fetchPropertiesForMatching(true) : await this.fetchCustomersForMatching(true);
				this.items = res.data.properties ? res.data.properties : res.data.customers;
			},
			deep: true
		},
		propertiesForMatchingPopupMatchCustomer: {
			async handler(val) {
				this.items = val.properties;
			},
			deep: true
		},
		customersForMatchingPopupMatchProperty: {
			async handler(val) {
				this.items = val.customers;
			},
			deep: true
		}
	},
	async mounted() {
		console.log(this.parentType);
		this.$refs.matchSearch.$refs.searchInput.focus();
		this.sortDataObj = {
			sortBy: this.parentType === 'customer' ? 'title' : 'last_name',
			order: 'asc'
		};
	},
	components: {
		PartInputSearch,
		SvgIcon,
		PartNoResults,
		PartLoaderBig,
		BlockCustomTable
	},
	methods: {
		closePopup() {
			this.$emit('closePopupCustomer');
		},
		async loadMore() {
			this.parentType === 'customer' ? await this.fetchPropertiesForMatching(false) : await this.fetchCustomersForMatching(false);
		},
		sortData(item) {
			this.sortDataObj = item;
		},
		async fetchPropertiesForMatching(initialLoad) {
			const { current_page: currentPage, last_page: lastPage, next: nextPage } = this.propertiesForMatchingPopupMatchCustomer;
			if (!initialLoad && (this.fetchInProgress || currentPage === lastPage)) return;
			const obj = {
				filter: this.filter,
				order_by: this.sortDataObj.sortBy.replace('_label', '').replace('_customer', ''),
				order: this.sortDataObj.order,
				id: this.$route.params.id,
				page: initialLoad ? 1 : nextPage,
				scroll: !initialLoad
			};
			this.fetchInProgress = true;

			const res = await this.$store.dispatch('propertiesForMatchingPopupMatchCustomer', obj);
			initialLoad && this.$refs.tableRef.$refs.tableCustom.scrollTo(0, 0);
			this.fetchInProgress = false;

			return res;
		},
		async fetchCustomersForMatching(initialLoad) {
			const { current_page: currentPage, last_page: lastPage, next: nextPage } = this.customersForMatchingPopupMatchProperty;
			if (!initialLoad && (this.fetchInProgress || currentPage === lastPage)) return;

			const obj = {
				filter: this.filter,
				order_by: this.sortDataObj.sortBy.replace('_label', '').replace('_customer', ''),
				order: this.sortDataObj.order,
				id: this.$route.params.id,
				page: initialLoad ? 1 : nextPage,
				scroll: !initialLoad
			};
			this.fetchInProgress = true;

			const res = await this.$store.dispatch('customersForMatchingPopupMatchProperty', obj);
			initialLoad && this.$refs.tableRef.$refs.tableCustom.scrollTo(0, 0);
			this.fetchInProgress = false;

			return res;
		},
		sendEmailPopup(pivot) {
			pivot.manualFlag = true;
			if (this.propertyInfo.eretz_pdf) {
				this.data.DataMatchCustomer.eretzPdf = this.propertyInfo.eretz_pdf;
			}
			this.$emit('sendEmailPopup', pivot);
		}
	}
};
</script>

<style lang="scss" scoped>
.close-icon {
	position: absolute;
	right: 15px;
	top: 15px;
	color: $fiord;
	font-size: 20px;
	transition: $dur $ease;
	cursor: pointer;

	@include hover {
		color: $dodger-blue;
	}
}

.popup__wrap-box {
	padding: 20px;
	max-height: 80vh;
	min-height: 60vh;

	@include mq(640p) {
		min-height: 50vh;
	}
}

.popup__wrap {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 999999;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba($slate-gray, .5);
}

.popup {
	max-width: 1216px;
	width: 100%;
	background-color: $white;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;
	padding: 22px 20px 42px;

	@include mq($lg) {
		padding: 40px 20px;
	}

	@include mq($sm) {
		padding: 40px 15px;
	}
}

.popup__title {
	margin-bottom: 17px;
	font-size: 20px;

	@include mq($lg) {
		font-size: 18px;
		margin-bottom: 20px;
	}

	@include mq($md) {
		font-size: 16px;
	}

	@include mq($sm) {
		font-size: 15px;
	}
}

.popup__btn-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 50px;
	max-width: 100%;
	width: 100%;

	@include mq($lg) {
		padding: 0 30px;
		justify-content: space-around;
	}

	@include mq($sm) {
		padding: 0 20px;
	}
}

.popup__btn {
	@include mq(400px) {
		padding: 5px;
		max-width: 100px;
	}
}

.popup__btn {
	align-self: flex-end;
	margin-left: auto;
	display: flex;
	align-items: center;
}

.popup__table {
	margin-bottom: 25px;

	@include mq($lg) {
		margin-bottom: 15px;
	}

	&.popup__table--no-checkbox {
		/deep/
		.custom-table__table {
			th {
				.checkbox-wrap {
					display: none;
				}
			}
		}
	}
}

.popup__wrap-no-results {
	max-height: 376px;
	position: absolute;
	width: 100%;
	left: 0;
	top: 150px;
	pointer-events: none;
}

.fade-effect-active, .fade-effect-active {
transition: opacity .3s;
}
.fade-effect, .fade-effect-leave-to /* .fade-leave-active below version 2.1.8 */ {
opacity: 0;
}
</style>
